/**
 * Email Verification Route
 * Guides the user to verify their email and supports resending the email
 */

import React, { useState, useEffect } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { EmailVerificationPage } from '../pages/Auth/EmailVerificationPage'
import { requireGuest } from '../router/guards'
import { authService } from '../services/auth.service'

interface SearchParams {
  email?: string
}

const EmailVerificationRouteComponent = () => {
  const navigate = useNavigate()
  const search = useSearch({ from: '/email-verification' }) as SearchParams
  const email = search.email ?? ''

  return (
    <EmailVerificationPage
      email={email}
      onVerify={async () => {
        // This page is for manual check/resend
      }}
      onResend={async ({ email }) => {
        await authService.resendVerificationEmail(email)
      }}
      onBackToLogin={() => navigate({ to: '/login' })}
    />
  )
}

export const Route = createFileRoute('/email-verification')({
  beforeLoad: requireGuest,
  component: EmailVerificationRouteComponent,
})
